<template>
  <div class="contact mt-4">
    <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
    <form @submit.prevent="sendContact">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-12">
            <app-input
              label="Assunto"
              v-model="contact.subject"
              required
            ></app-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <b-field label="Mensagem" required>
              <editor
                v-model="contact.message"
                :api-key="tinyMceApiKey"
                :init="tinyMceConfig"
              ></editor>
            </b-field>
          </div>
        </div>
        <div class="row mt-4 buttons">
          <div class="text-center">
            <button :disabled="$v.$invalid" type="submit" v-app-button>
              Enviar
            </button>
          </div>
          <div>
            <a
              href="https://api.whatsapp.com/send?phone=5541992678525"
              target="_blank"
              class="whatsapp-contact"
            >
              <img src="@/assets/img/whatsapp.svg" alt="Ícone WhatsApp" />
              <span>Entre em contato via Whatsapp.</span>
            </a>
          </div>
        </div>
        <div class="row mt-4"></div>
      </div>
    </form>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';

import { required } from 'vuelidate/lib/validators';

import { TYNEMCE } from '@/constants/tinymce.constants';
import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'contact-page',
  components: { Editor },
  data: () => {
    return {
      isLoading: false,
      tinyMceApiKey: TYNEMCE.API_KEY,
      tinyMceConfig: {
        height: 500,
        menubar: false,
        plugins: TYNEMCE.PLUGINS,
        toolbar: TYNEMCE.TOOLBAR,
      },
      contact: {
        subject: null,
        message: null,
      },
    };
  },
  validations() {
    return {
      contact: {
        subject: { required },
        message: { required },
      },
    };
  },
  methods: {
    sendContact() {
      this.isLoading = true;

      ClientService.sendContact({ ...this.contact })
        .then(() => {
          this.contact.subject = null;
          this.contact.message = null;
          this.toastify('Mensagem enviada com sucesso!');
        })
        .catch(() => {
          this.toastify(
            'Erro ao enviar mensagem. Tente novamente mais tarde.',
            'error'
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.contact {
  .buttons {
    padding: 1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    .whatsapp-contact {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-left: 40px;
      span {
        margin-left: 10px;
      }

      img {
        width: 30px;
        height: 30px;
        color: #50cc5d;
      }
    }
  }
}
</style>
